import React from 'react';
import type { DataGridCellRendererProps } from '@myosh/odin-components';
import { DataGridDataCell, useTestTag } from '@myosh/odin-components';
import { useRiskRatingMatrixConfigQuery } from '../../redux/services/risk-matrix';
import type { RiskMatrixDataItem } from '../../@types/risk-matrix-field';
import type { EntityReference } from '../../@types/views';
import { forceAssert } from '../../utils/type-guards';
import { getRiskRatingCellAttributes } from '../../utils/risk-rating-utils';

interface RiskMatrixRowData {
  id: number;
  consequence: RiskMatrixDataItem;
  likelihood: RiskMatrixDataItem;
  riskLevel: RiskMatrixDataItem;
  category: number;
  displayValue: string;
}

const RiskRatingDataCell = ({ column, rowData }: DataGridCellRendererProps) => {
  const columnEntityReference = forceAssert<EntityReference>(column.customDataProperties);
  const { entityId, displayRecordListColour, riskMatrixId } = columnEntityReference;
  const { data: riskMatrixData } = useRiskRatingMatrixConfigQuery(riskMatrixId);
  const riskMatrixRowData = forceAssert<RiskMatrixRowData>(rowData[entityId]);

  const cellAttributes = riskMatrixData && getRiskRatingCellAttributes(riskMatrixData, riskMatrixRowData?.id);

  const tagCreator = useTestTag('risk-rating-cell');
  return riskMatrixRowData?.displayValue ? (
    <div ref={tagCreator('')} style={(displayRecordListColour && cellAttributes) || { backgroundColor: 'transparent' }}>
      <DataGridDataCell value={riskMatrixRowData?.displayValue} width={column.width} />
    </div>
  ) : null;
};

export default RiskRatingDataCell;
